'use client';

import { Button, Container, Stack, Text, Title, Paper, Center } from '@/components/lib/shadcn-core-compat';
import { IconTools } from '@/components/lib/tabler-lucide';
import Link from 'next/link';
import { settings } from '../../config/settings';
import { useTranslations } from 'next-intl';

type MaintenancePageProps = {
  description?: string;
  startAt?: string;
  endAt?: string;
};

function formatWindow(startAt, endAt) {
  if (!startAt) return null;
  try {
    const start = new Date(startAt);
    const startText = start.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
    if (!endAt) return `Started ${startText}`;
    const end = new Date(endAt);
    const endText = end.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
    return `${startText} – ${endText}`;
  } catch (_) {
    return null;
  }
}

export default function MaintenancePage({ description, startAt, endAt }: MaintenancePageProps = {}) {
  const t = useTranslations('Auto.MaintenancePage');
  const message = description?.trim()
    || settings.maintenance_mode?.message
    || t('weReCurrentlyPerforming');
  const windowText = formatWindow(startAt, endAt);

  return (
    <Container size="sm" mt="15rem" mb="6rem">
      <Paper p="xl" withBorder>
        <Stack align="center" gap="xl">
          <Center>
            <IconTools size={80} className="text-primary" />
          </Center>

          <Title order={1} ta="center">
            {t('underMaintenance')}
          </Title>

          <Text size="lg" c="dimmed" ta="center" maw={400}>
            {message}
          </Text>

          {windowText && (
            <Text size="sm" c="dimmed" ta="center">
              {windowText}
            </Text>
          )}

          <Button
            component={Link}
            href="/login"
            size="lg"
            variant="gradient"
            gradient={{ from: 'violet', to: 'grape' }}
          >
            {t('staffSignIn')}
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}
